var regex=/[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

export default regex;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/node_modules/uc.micro/categories/Z/regex.js